// See https://developer.mozilla.org/en-US/docs/Glossary/Void_element
export const VOID_HTML_ELEMENTS = [
  'area',
  'base',
  'br',
  'col',
  'embed',
  'hr',
  'img',
  'input',
  'link',
  'meta',
  'param',
  'source',
  'track',
  'wbr',
]
